import { styled } from '@mui/material';

export const CloseButtonStyled = styled('button')`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 30px;
  height: 30px;
  z-index: 3;
  top: ${({ isFullscreen }: { isFullscreen: boolean }) => (!isFullscreen ? '15px' : '68px')};
  right: ${({ isFullscreen }: { isFullscreen: boolean }) => (!isFullscreen ? '-33px' : '18px')};
  border-radius: 50%;
  background-color: #292929;

  cursor: pointer;

  svg,
  i {
    color: #fff;
    font-size: 14px;
    transition: all 0.3s ease;
  }

  &:hover {
    svg,
    i {
      color: #ea475c;
    }
  }

  @media screen and (max-width: 425px) and (orientation: portrait) {
    right: ${({ isFullscreen }: { isFullscreen: boolean }) => (!isFullscreen ? '-15px' : '18px')};
  }
`;

export const FullscreenButtonStyled = styled('button')`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 30px;
  height: 30px;
  z-index: 3;
  border-radius: 50%;
  top: ${({ isFullscreen }: { isFullscreen: boolean }) => (!isFullscreen ? '48px' : '100px')};
  right: ${({ isFullscreen }: { isFullscreen: boolean }) => (!isFullscreen ? '-33px' : '18px')};
  background-color: #ea475c;

  cursor: pointer;

  svg,
  i {
    color: #fff;
    font-size: 14px;
    transition: all 0.3s ease;
  }

  &:hover {
    svg,
    i {
      color: #292929;
    }
  }

  @media screen and (max-width: 425px) and (orientation: portrait) {
    top: ${({ isFullscreen }: { isFullscreen: boolean }) => (!isFullscreen ? '52px' : '100px')};
    right: ${({ isFullscreen }: { isFullscreen: boolean }) => (!isFullscreen ? '-15px' : '18px')};
  }
`;

export const ContainerStyled = styled('div')({
  background: '#fff',
  position: 'absolute',
  // height: ${({ height }: { height: number }) => height},
  // width: ${({ width }: { width: number }) => width},
  maxWidth: 'calc(100vw - 72px)',
  maxHeight: '100vh',
  top: 0,
  left: 0,
  zIndex: 150,
  right: 0,
  bottom: 0,
  margin: 'auto',
  textAlign: 'center',
  display: 'inline-block',
  overflowY: 'clip',
});
